import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Service from './Service.js';
import debounce from '../utils/debounce.js';

class Scroll extends Service {
  constructor() {
    super(...arguments);

    _defineProperty(this, "y", window.pageYOffset);

    _defineProperty(this, "yLast", window.pageYOffset);

    _defineProperty(this, "x", window.pageXOffset);

    _defineProperty(this, "xLast", window.pageXOffset);
  }

  init() {
    document.addEventListener('scroll', this, {
      passive: true,
      capture: true
    });
    return this;
  }

  get debouncedHandler() {
    var debounced = debounce(() => {
      this.trigger(this.props);
    }, 0);
    Object.defineProperty(this, 'debouncedHandler', {
      value: debounced
    });
    return debounced;
  }

  handleEvent() {
    this.trigger(this.props);
    this.debouncedHandler();
  }

  kill() {
    document.removeEventListener('scroll', this);
    return this;
  }

  get props() {
    this.yLast = this.y;
    this.xLast = this.x;

    if (window.pageYOffset !== this.y) {
      this.y = window.pageYOffset;
    }

    if (window.pageXOffset !== this.x) {
      this.x = window.pageXOffset;
    }

    return {
      x: this.x,
      y: this.y,
      changed: {
        x: this.x !== this.xLast,
        y: this.y !== this.yLast
      },
      last: {
        x: this.xLast,
        y: this.yLast
      },
      delta: {
        x: this.x - this.xLast,
        y: this.y - this.yLast
      },
      progress: {
        x: this.max.x === 0 ? 1 : this.x / this.max.x,
        y: this.max.y === 0 ? 1 : this.y / this.max.y
      },
      direction: {
        x: this.x > this.xLast ? 'RIGHT' : this.x < this.xLast ? 'LEFT' : 'NONE',
        y: this.y > this.yLast ? 'DOWN' : this.y < this.yLast ? 'UP' : 'NONE'
      },
      max: this.max
    };
  }

  get max() {
    return {
      x: (document.scrollingElement || document.body).scrollWidth - window.innerWidth,
      y: (document.scrollingElement || document.body).scrollHeight - window.innerHeight
    };
  }

}

var scroll = null;
export default function useScroll() {
  if (!scroll) {
    scroll = new Scroll();
  }

  var add = scroll.add.bind(scroll);
  var remove = scroll.remove.bind(scroll);
  var has = scroll.has.bind(scroll);

  var props = () => scroll.props;

  return {
    add,
    remove,
    has,
    props
  };
}